import {
  IWorkingHoursFormModel,
  IWorkingHoursSlot,
} from "../validation/workingHoursValidation";

export interface IWorkingHoursDay {
  dayOfWeek: number; // 0=Sunday, 1=Monday, etc.
  slots: IWorkingHoursSlot[];
}

export interface IWorkingHoursData {
  studioId?: number | null;
  userId?: number | null;
  days: IWorkingHoursDay[];
}

// Define only the day keys (exclude studioId and userId)
export type DayKey =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export const workingHoursFormDefaultValues: IWorkingHoursFormModel = {
  studioId: null,
  userId: null,
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: [],
};

export const DAYS_OF_WEEK: { key: DayKey; name: string; dayOfWeek: number }[] =
  [
    { key: "monday", name: "Понеделник", dayOfWeek: 1 },
    { key: "tuesday", name: "Вторник", dayOfWeek: 2 },
    { key: "wednesday", name: "Сряда", dayOfWeek: 3 },
    { key: "thursday", name: "Четвъртък", dayOfWeek: 4 },
    { key: "friday", name: "Петък", dayOfWeek: 5 },
    { key: "saturday", name: "Събота", dayOfWeek: 6 },
    { key: "sunday", name: "Неделя", dayOfWeek: 0 },
  ];
